import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CreditCardService } from '../../../shared/cards/credit-card.service';
import { StatusCreditCard } from '../../../shared/cards/credit-card-status.enum';

@Component({
	selector: 'app-cards-credit-activation-step1',
	templateUrl: './credit.component.html',
	encapsulation: ViewEncapsulation.None
})
export class CardsCreditComponent implements OnInit {
	public userName: string;
	public img: any;

	constructor(private router: Router, private creditCardService: CreditCardService) {}

	ngOnInit(): void {
		this.checkStatus();
	}

	checkStatus() {
		switch (this.creditCardService.status) {
			case StatusCreditCard.APROVADO: {
				this.redirectTo('cartoes-ativacao/credito/step1');
				break;
			}
			case StatusCreditCard.NAOPROCESSADO: {
				this.redirectTo();
				break;
			}
			case StatusCreditCard.FINALIZADO: {
				this.redirectTo('cartoes-ativacao/credito/step3');
				break;
			}
			case StatusCreditCard.RECUSADO: {
				this.redirectTo('cartoes-ativacao/credito/reprovado');
				break;
			}
		}
	}

	redirectTo(url: string = '') {
		this.router.navigate([url]);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/cards-activation/credit/credit.component.ts